module.exports = __webpack_public_path__ + "static/Bette-Wylie-Aitken-800x500-a2510501b8cb8386c5d3ed2560a9b848.jpg";